export const FuseConfig = {
  threshold: 0.1,
  location: 0,
  distance: 100,
  includeScore: true,
  shouldSort: true,
  useExtendedSearch: true,
  minMatchCharLength: 1,
  ignoreLocation: true,
};
